import { contactCard } from '../../../shared';

export const sellerTCCard = contactCard(
  'sellerSideContacts.sellerTC',
  'counterpartyTransactionCoordinator',
);
